import Stack from '@admin/components/stack'
import Downloading from './downloading'
import PropTypes from 'prop-types'
import Browser from './browser'
import Profile from './profile'
import Chooser from './chooser'
import Edit from './edit'
import React from 'react'

class CanvaDesign extends React.Component {

  static propTypes = {
    onBack: PropTypes.func,
    onDone: PropTypes.func
  }

  stackRef = React.createRef()

  _handleBrowser = this._handleBrowser.bind(this)
  _handleChooser = this._handleChooser.bind(this)
  _handleEdit = this._handleEdit.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleDownloading = this._handleDownloading.bind(this)

  render() {
    return <Stack { ...this._getStack()} />
  }

  componentDidMount() {
    this._handleProfile()
  }

  _getStack() {
    return {
      display_name: 'canva browser',
      ref: this.stackRef
    }
  }

  _handleDone(social_campaign) {
    this.props.onDone({
      assets: social_campaign.assets,
      title: social_campaign.title
    })
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handleBrowser(profile) {
    const { onBack } = this.props
    this._handlePush(Browser, {
      profile,
      onBack,
      onDone: this._handleDownloading
    })
  }

  _handleChooser(design) {
    const { onBack } = this.props
    this._handlePush(Chooser, {
      design,
      onBack,
      onDone: this._handleEdit
    })
  }

  _handleDownloading(design) {
    this._handlePush(Downloading, {
      design,
      onNext: this._handleDone
    })
  }

  _handleEdit(design) {
    this._handlePush(Edit, {
      design,
      onDone: this._handleDownloading
    })
  }

  _handleProfile() {
    const { onBack } = this.props
    this._handlePush(Profile, {
      onBack,
      onDone: this._handleChooser
    })
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

}

export default CanvaDesign

